import React from 'react';
import MultiSelect from './MultiSelect';
import { withStyles} from '@material-ui/core';

class StatusFilter extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            multiValue: []
          };
        this.statusOptions = [{ value: 0, label: "Active" }, { value: 1, label: "InActive" }];
      }

      handleStatusFilterChange=(selectedValue)=>{
          this.setState({multiValue:selectedValue});
          this.props.filterbasedstatus(selectedValue,"statusfilter");
      };
      componentDidUpdate(prevProps){
        if(prevProps.ContentList !== this.props.ContentList){
          this.handleStatusFilterChange([]);
        }
     }

      render(){
          return(
              <>
                <MultiSelect
                options={this.statusOptions}
                name={"Status"}
                isMulti
                checkBoxStyled
                onChange={this.handleStatusFilterChange}
                value={this.state.multiValue}
                isSearchable = {false}
                isClearable = {false}
                placeholder = {this.state.multiValue&&this.state.multiValue.length>0?"Status ":"Status : All "}
                textFieldProps={{
                  variant:"outlined",
                  label:''
              }}
                >
                </MultiSelect>
              </>
          );
      }
}

export default (withStyles()(StatusFilter));